import React, { useEffect, useRef, useState } from "react";
import { logoutfunc } from "../../service/commonFunc";
import power_settings_new from "../../assets/images/power_settings_new.svg";
import "../../Styles/Common/LogoutDropdown.scss";
import DropdownImg from "../../assets/images/expand_more_white.svg";
import CloseIcon from "../../assets/images/clear.svg";

const LogoutDropdown = ({ Initial }) => {
  const [userActive, setUserActive] = useState(false);
  const dropdownRef = useRef(null);

  const userDropdown = () => {
    setUserActive(!userActive);
  };
  const userDropdownClose = () => {
    setUserActive(false);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserActive(false);
      }
    };
    if (userActive) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userActive]);

  return (
    <div className="user" ref={dropdownRef}>
      <div className="user-dropdown">
        <div
          className={`box ${userActive ? "active" : "no-active"}`}
          onClick={userDropdown}
        >
          <div className="name">{Initial}</div>
          <img src={DropdownImg} alt="Dropdown" className="DropdownImg" />
        </div>
        <div
          className={`dropdown ${userActive ? "show" : "no-show"}`}
          onMouseLeave={userDropdownClose} // Hide dropdown on mouse leave
        >
          <div className="accountHeading">Account</div>
          <div onClick={userDropdownClose}>
            <img src={CloseIcon} className="close" alt="close" />
          </div>
          <ul>
            <li>
              <div onClick={() => logoutfunc()}>
                <img src={power_settings_new} alt="Logout" />
                Logout
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LogoutDropdown;
